/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import { Button, Flex, Text } from "@paguelofacil/pf-components";

import { language, languageDefault } from "../services/utils/Language";
import { STEPS } from "../services/utils/Constants";
import { useLoginCryptofacil } from "../hooks/useLogin";

import { InputTextEmail } from "./Inputs/Email";

const LoginForm = ({ handleChangeForm, valuesForm, setStep, setIsLoading }) => {
    const navigate = useNavigate();
    const { isLoadingLogin, loginAccountCryptofacil } = useLoginCryptofacil();

    const handleSubmit = async event => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const responseLogin = await loginAccountCryptofacil(valuesForm.email);

            if (!responseLogin) {
                return;
            }

            setStep(STEPS.VALIDATE_CODE);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const shouldDisabledButtonNext = !valuesForm.email;

    useEffect(() => {
        setIsLoading(isLoadingLogin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingLogin]);

    return (
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <Flex gap="1.25rem" direction="column">
                <InputTextEmail
                    label={<FormattedMessage id={language.email} defaultMessage={languageDefault.email} />}
                    name="email"
                    placeholder="correo.user@mail.com"
                    onChangeValue={value => handleChangeForm("email", value)}
                    isRequired={true}
                />
                <Button
                    className="button-primary-cf"
                    fullWidth
                    size="md"
                    type="submit"
                    style={{ marginTop: "1.25rem" }}
                    disabled={shouldDisabledButtonNext}
                >
                    <FormattedMessage id={language.next} defaultMessage={languageDefault.next} />
                </Button>
                <Text
                    variant="caption"
                    weight="regular"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <FormattedMessage
                        id={language.do_not_you_has_account}
                        defaultMessage={languageDefault.do_not_you_has_account}
                    />
                    &nbsp;
                    <Button
                        variant="link"
                        handleClick={() => navigate("/cryptofacil/signup")}
                        style={{ color: "#378FA2" }}
                    >
                        <FormattedMessage id={language.signup} defaultMessage={languageDefault.signup} />
                    </Button>
                </Text>
            </Flex>
        </form>
    );
};

export default LoginForm;
